import { AnimatePresence } from 'framer-motion';
import React from 'react';
import Modal from '.';

const NewModal = ({ children, closeModal, goBack }) => {
	return (
		<div className="modal">
			<AnimatePresence>
				<Modal closeModal={closeModal} goBack={goBack}>
					{children}
				</Modal>
			</AnimatePresence>
		</div>
	);
};

export default NewModal;
